export const designationList = "DESIGNATION_LIST";